// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2xM9e","alert":"SettungsInbox_alert__F5luL"};